var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarIconAwesomeConfirm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.886,
    height: 20.125,
    viewBox: "0 0 21.886 20.125",
    fill: "#cae7f1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Octicons-checklist",
    d: "M21.746,139.1l-1.424-1.419a.467.467,0,0,0-.668,0l-3,3-3.434,3.441-2.659-2.662a.471.471,0,0,0-.672,0l-1.421,1.42a.475.475,0,0,0,0,.674l3,3,.514.511.906.909a.473.473,0,0,0,.674,0l1.419-1.42,6.771-6.778A.472.472,0,0,0,21.746,139.1ZM6.531,140.944l1.42-1.424a3.285,3.285,0,0,1,4.539,0l.724.724,3.252-3.1V128H0v20.125H9.148l-2.617-2.634A3.223,3.223,0,0,1,6.531,140.944ZM5.489,129.83h9.148v1.83H5.489Zm0,3.659h9.148v1.83H5.489Zm-1.83,5.489H1.83v-1.83h1.83Zm0-3.659H1.83v-1.83h1.83Zm0-3.659H1.83v-1.83h1.83Zm1.83,5.489h1.83v1.83H5.489Z",
    transform: "translate(0 -128)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconAwesomeConfirm);
export default __webpack_public_path__ + "static/media/Sidebar-Icon-awesome-confirm.6186582b9b3e396501acf4d78fc64166.svg";
export { ForwardRef as ReactComponent };